/**
 * Epics Kanban Configuration
 *
 * Configuration for the Epics kanban board using the global Kanban component.
 */

import { KanbanConfig } from '../types';
import { Epic, EpicStatus } from 'shared/types/epic';
import { epicPhaseColumns } from 'screens/bug-reports/epics/epicStatusConfig';

/**
 * Epics Kanban Configuration
 *
 * This config defines how the Epics kanban should look and behave:
 * - Uses phase columns from epicStatusConfig (single source of truth)
 * - Shows count per column
 * - Non-scrollable columns (full height)
 */
export const epicsKanbanConfig: KanbanConfig<Epic, EpicStatus> = {
  // Column definitions from epicStatusConfig
  columns: epicPhaseColumns,

  // Get the status for an epic
  getItemStatus: (epic: Epic) => epic.status,

  // Show count badge per column
  showCount: true,

  // No add button for epics
  showAddButton: false,

  // Empty state configuration
  emptyState: {
    message: 'Geen epics',
  },

  // Columns are not scrollable (they stretch to full height)
  scrollableColumns: false,
};
